import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable, forkJoin } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { EVersionType } from 'src/app/shared/enums/rule.enums';
import { IRuleVersion } from 'src/app/shared/interfaces/rule.interfaces';
import { SaveService } from 'src/app/services/save.service';
import { RuleService } from 'src/app/services/rule.service';

import { IBucketResolver } from './entities/bucket.interfaces';

@Injectable()
export class BucketResolver {
  constructor(
    private router: Router,
    private saveService: SaveService,
    private ruleService: RuleService
  ) {}

  resolve(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
    routerStateSnapshot: RouterStateSnapshot,
    activatedRoute: ActivatedRoute
  ): Observable<unknown | IBucketResolver> {
    const versionId = activatedRouteSnapshot.paramMap.get('versionId');

    let ruleVersion: Observable<IRuleVersion>;

    if (versionId === 'new') {
      ruleVersion = this.ruleService
        .createVersion({ version_type: EVersionType.draft })
        .pipe(
          tap(({ id }: IRuleVersion) => {
            this.router.navigate([`${this.router.url}/${id}/rules`]);
          })
        );
    } else {
      ruleVersion = this.ruleService.getVersion(parseInt(versionId));
    }

    return forkJoin([
      // Rule Version
      ruleVersion,
      // Categories
      this.ruleService.getCategoriesList(1, 999, ''),
    ]).pipe(
      map(
        ([
          // Rule Version
          ruleVersion,
          // Categories
          categories,
        ]) => ({
          ruleVersion,
          categories: categories.items,
        }),
        catchError((error: Error) =>
          this.errorAction(activatedRoute, error?.message)
        )
      )
    );
  }

  private errorAction(
    activatedRoute: ActivatedRoute,
    errorMessage: string
  ): Observable<unknown> {
    this.router.navigate(['..'], { relativeTo: activatedRoute });
    this.saveService.initSnackBar(
      false,
      'Ocorreu um erro! Tente novamente ou fale com o suporte pelo botão de ajuda.'
    );

    throw new Error(errorMessage);
  }
}
